import React, {useState} from 'react'
import {Collapse} from 'react-collapse'
import './Text.scss'

export default function Text({expandable, text, hiddenText, maxWidth}) {
	const [showText, setShowText] = useState(false)

	if(expandable) {
		return(
			<div className={`Text ${maxWidth ? 'max-width' : ''}`} aria-live="polite">
				<div className="text" dangerouslySetInnerHTML={{__html: text}} />
				<Collapse isOpened={showText}>
					<div aria-hidden={!showText} className="text" dangerouslySetInnerHTML={{__html: hiddenText}} />
				</Collapse>
				<button aria-label={showText ? 'Vis mindre tekst over' : 'Vis mer tekst over'} aria-expanded={showText} className={`showMore ${showText ? 'active' : ''}`} onClick={() => setShowText(!showText)}>
					{showText ? 'Vis mindre' : 'Vis mer'}
					<svg xmlns="http://www.w3.org/2000/svg" width="15.51" height="17.774" viewBox="0 0 15.51 17.774">
						<g transform="translate(28.389 -12) rotate(90)">
							<path d="M35.712,20.634,29.879,14.8,31.8,12.879l7.755,7.755L31.8,28.389l-1.922-1.922Z" transform="translate(-9.781)" />
							<path d="M12,27H26.947v2.718H12Z" transform="translate(0 -7.725)" />
						</g>
					</svg>
				</button>
			</div>
		)
	}
	return(
		<div className={`Text ${maxWidth ? 'max-width' : ''}`} dangerouslySetInnerHTML={{__html: text}} />
	)
}